import balanceScale from "@/../../hypetrain/static/img/balance-scale.png";
import bullseye from "@/../../hypetrain/static/img/bullseye.png";
import achieve1 from "@/../../hypetrain/static/img/for-business/achieve1-1.png";
import achieve3 from "@/../../hypetrain/static/img/for-business/achieve1-3.png";
import leadership from "@/../../hypetrain/static/img/leadership.png";
import { SITE_NAME } from "@/css/constants";
import { MarketingPageBenefits, MarketingPageConfig } from "@/types/marketing";

import { CTAMini } from "./CTAMini";

const options: MarketingPageConfig = {
  page: "LEADERSHIP_COACHING",
  color: "#EA9924",
  metaTitle: `Online Leadership Coaching - ${SITE_NAME}`,
  metaDescription:
    "Challenge yourself to grow as a leader. Gain a better understanding of your strengths and weaknesses. Develop your unique leadership style. Hone your communication skills, ability to influence, and executive presence.",
  metaImage:
    "https://placement-pub.s3.us-east-2.amazonaws.com/leadership-meta.png",
  defaultHeadline: "Leadership Coaching",
  defaultSubHeader:
    "Meet 1:1 with an expert coach to level up and set yourself apart as a leader.",
  benefitsHeadline: "Get set up in no time",
  ctaText: "Grow faster with a coach",
  pricingIntro: "",
  audience: "D2C",
  serviceType: "session",
  specialtySlug: "leadership-coaching",
  FAQCategory: "Basics",
  marketingVideoId: 673995906,
  background: "linear-gradient(-25deg,#38ced1 30%,#2474e7 76%)",
  brandBg: "#123568",
  heroGraphic: leadership,
  heroGraphicWidth: "100%",
  playDark: true,
  pricingCTA: <CTAMini />,
  upsell: true,
  ctaLink: "/demo",
  ctaButtonText: "Talk to Sales",
  useCases: [
    "team-building",
    "virtual-leadership",
    "feedback",
    "grow-manager",
    "exec-presence",
    "imposter-syndrome",
    "manage-up",
    "conflict",
  ],
};

const benefits: MarketingPageBenefits = {
  title: "Everybody Needs a Coach",
  subtitle: "Even seasoned leaders perform better with a coach",
  items: [
    {
      title: "Grow as a Leader",
      description: (
        <>
          Improve your communication skills, deliver better feedback, and
          inspire your team.
        </>
      ),
      photo: achieve1,
      bgColor: "#FEF0ED",
    },
    {
      title: "Sharpen Your Focus",
      description: (
        <>
          Tame the mayhem and get clarity on the highest impact, high-priority
          uses of your time.
        </>
      ),
      photo: balanceScale,
      bgColor: "#FDF7E9",
    },
    {
      title: "Achieve Your Goals",
      description: (
        <>
          Discover your values, articulate your goals, and chart your course.
          With a coach, it's possible.
        </>
      ),
      photo: bullseye,
      bgColor: "#EBF3FD",
    },
    {
      title: "World-Leading Expertise",
      description: (
        <>
          You will solve challenges by partnering with a coach who has been in
          your shoes.
        </>
      ),
      photo: achieve3,
      bgColor: "#E9F7EF",
    },
  ],
};

export default {
  options,
  benefits,
};
